/**
 * Processing state of an AI-assisted rebate load step (column-mapping suggestion, conversion suggestion, …), as exposed to the UI. Mirrors
 * RebateLoadAiProcessingStatus; shared by all AI suggestion models.
 */
export enum RebateLoadAiProcessingStatusModel {
	InProgress = 1,
	Completed = 2,
	Failed = 3
}
